import { apiClient } from '../../api/client';
import { ApiResponse, PagedResponse } from '../../api/types';
import { EventFilters, EventInput, GameEvent, HalloweenReward, HalloweenSpin, HalloweenUserFilters, HalloweenUserProgress } from './types';

export async function listEvents(params: EventFilters): Promise<GameEvent[]> {
  const response = await apiClient.get<ApiResponse<GameEvent[]>>('/api/v1/admin/events', { params });
  return response.data.data;
}

export async function createEvent(input: EventInput & { slug: string }): Promise<GameEvent> {
  const response = await apiClient.post<ApiResponse<GameEvent>>('/api/v1/admin/events', input);
  return response.data.data;
}

export async function updateEvent(id: number, input: EventInput): Promise<GameEvent> {
  const response = await apiClient.put<ApiResponse<GameEvent>>(`/api/v1/admin/events/${id}`, input);
  return response.data.data;
}

const halloweenURL = '/api/v1/admin/events/halloween-2026/users';

export async function listHalloweenUsers(params: HalloweenUserFilters): Promise<PagedResponse<HalloweenUserProgress>> {
  const response = await apiClient.get<PagedResponse<HalloweenUserProgress>>(halloweenURL, { params });
  return response.data;
}

export async function listHalloweenSpins(userID: string, page: number, perPage: number): Promise<PagedResponse<HalloweenSpin>> {
  const response = await apiClient.get<PagedResponse<HalloweenSpin>>(`${halloweenURL}/${userID}/spins`, { params: { page, per_page: perPage } });
  return response.data;
}

export async function listHalloweenRewards(userID: string, page: number, perPage: number): Promise<PagedResponse<HalloweenReward>> {
  const response = await apiClient.get<PagedResponse<HalloweenReward>>(`${halloweenURL}/${userID}/rewards`, { params: { page, per_page: perPage } });
  return response.data;
}
